import {HandlerOf} from '../../libs/shared/helpers/src/react/reactHelpers';
import {ApiServerAttachment} from '../models/api/attachmentModel';
import {postFileAsync} from '../services/http/http';
import {CancelToken} from './asyncCancelHelpers';

/*
 * Helpers.
 */

export async function uploadAttachmentAsync(
  url: string,
  file: File,
  onProgressChanged?: HandlerOf<ProgressEvent<EventTarget>>,
  cancelToken?: CancelToken,
) {
  return postFileAsync(ApiServerAttachment, `${url}/attachments`, file, {
    cancelToken,
    onProgressChanged,
    timeout: 36000000, // 10 minutes.
  });
}
